import './ListSelect.css';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { get } from 'lodash-es';
import { useMemo } from 'react';
import { Icon } from '@icp/components';
import { Checkbox, Radio } from 'antd';
import { toSimpleValue } from '../SelectElement/utils';

function ListSelect(props) {
  const {
    className,
    value,
    options,
    loading,
    multiple,
    mapping,
    disabled,
    showCheckMark = false,
    renderOption,
    itemProps = {},
    selectedItemProps = {},
    listStyle = 'style1',
    size = 'medium',
    onChange,
    ...other
  } = props;

  const simpleValue = useMemo(() => {
    return toSimpleValue(value);
  }, [value]);

  const handleClick = (op) => {
    const thisValue = op[mapping.value];

    if (multiple) {
      const index = simpleValue.findIndex((v) => v === op[mapping.value]);
      if (index >= 0) {
        const newValue = [...simpleValue];
        newValue.splice(index, 1);
        onChange(newValue);
      } else {
        onChange([...simpleValue, thisValue]);
      }
    } else {
      onChange(thisValue);
    }
  };

  return (
    <div
      // designer 里修改 style 组件不刷新
      key={listStyle}
      {...other}
      className={clsx('icp-list-select', listStyle, `size-${size}`, className)}
    >
      {(options || []).map((op, opIndex) => {
        const selected = [].concat(simpleValue).includes(op[mapping.value]);
        const applySelectedProps = selected ? selectedItemProps : {};
        const selectedClassName = selected ? selectedItemProps.className : null;
        return (
          <button
            {...itemProps}
            {...applySelectedProps}
            key={op[mapping.value] || opIndex}
            className={clsx(
              'icp-list-select-item',
              { selected },
              itemProps.className,
              selectedClassName,
            )}
            disabled={disabled}
            onClick={() => handleClick(op)}
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {listStyle === 'style4' ? (
              multiple ? (
                <Checkbox checked={selected} />
              ) : (
                <Radio checked={selected} />
              )
            ) : null}
            {renderOption ? renderOption(op) : get(op, mapping.label)}
            {['style1', 'style2'].includes(listStyle) && showCheckMark && selected ? (
              <div className="icp-list-select-item-selected-indicator">
                <Icon name="material:check-rounded" size={12} />
              </div>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

ListSelect.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
      }),
    ),
  ]),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  multiple: PropTypes.bool,
  mapping: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    // Other key map to save
  }),
  disabled: PropTypes.bool,
  showCheckMark: PropTypes.bool,
  renderOption: PropTypes.func,
  itemProps: PropTypes.shape({}),
  selectedItemProps: PropTypes.shape({}),
  listStyle: PropTypes.oneOf(['style1', 'style2', 'style3', 'style4']),
  size: PropTypes.oneOf(['medium', 'large']),
  onChange: PropTypes.func,
};

export default ListSelect;
